import { DraftConfiguration } from '@/types';
import { t } from '@/utils/i18n';
import { isDraftConfigurationWithTextOrSpecialText } from './isDraftConfigurationType';

const isEmptyRegExp = /^[\s\n\r]*$/;

export const getIsEmptyOrDefaultText = (configuration: DraftConfiguration) => {
  if (isDraftConfigurationWithTextOrSpecialText(configuration)) {
    const text = configuration.text.content;
    return isEmptyRegExp.test(text) || text === t('general.defaultText');
  }

  return false;
};
